import React from 'react';
import { hexToRGB } from 'utils';
import { AGENDA_RANGE } from 'enums';
import './AgendaPreview.scss';

const AgendaPreview = props => {
	const { color, isPad, from, margin, includeHeaders, accentColor, range } = props;
	const fromButton = from === 'WidgetButton';
	const fromPreview = from === 'Preview';
	const backgroundColor = hexToRGB(accentColor, 0.1);
	const todayOnly = range === AGENDA_RANGE.TODAY;
	const showDayRow = !fromButton && !fromPreview;
	return (
		<div className="WidgetPreviews">
			<div className={!from ? 'hover-wrap' : null}>
				{!from && <div className="hover-container">Agenda Items</div>}
				<div id="agendaWidgetContainer" style={{ margin }}>
					{!fromButton && includeHeaders && (
						<div className="divider">
							<div className="line" style={{ backgroundColor: color }}></div>
							<h3 style={{ color }}>{todayOnly ? 'Daily Agenda' : 'Agenda'}</h3>
							<div className="line" style={{ backgroundColor: color }}></div>
						</div>
					)}
					<div className="agendaEventContainer">
						{showDayRow && todayOnly && (
							<div className="agendaTodayLabel" style={{ color }}>
								Today
							</div>
						)}
						{showDayRow && !todayOnly && <div className="agendaDayDate">{/* DAY & DATE */}</div>}
						<div className="agendaEvent">
							<div
								className="agendaLeftLine"
								style={{ backgroundColor: accentColor, width: fromButton ? '12px' : '3%' }}
							></div>
							{isPad ? (
								<div className="agendaEventBody-pad" style={{ backgroundColor }}>
									<div className="time-container-pad">
										<div className="agendaEventTime">{/* Start Time */}</div>
										<div className="agendaEventTime">{/* End Time */}</div>
									</div>
									<div className="agendaEventDetails">
										<div className="eventDetails">
											<div className="eventName" style={{ backgroundColor: accentColor }}>
												{/* Location */}
											</div>
											<div className="eventLocation">{/* Event Location */}</div>
											<div className="eventDesc">{/* Description */}</div>
										</div>
										{/* Materials here if needed? */}
									</div>
								</div>
							) : (
								<div
									className="agendaEventBody"
									style={{
										backgroundColor,
										padding: fromButton || fromPreview ? '.75em 1em' : '1.5em',
									}}
								>
									<div className="agendaEventTime" style={{ height: fromButton ? '.5em' : '.9em' }}>
										{/* Time */}
									</div>
									<div className="agendaEventDetails">
										<div className="eventDetails">
											<div
												className="eventName"
												style={{
													backgroundColor: accentColor,
													height: fromButton ? '.7em' : fromPreview ? '.8em' : '1.1em',
												}}
											>
												{/* Location */}
											</div>
											<div
												className="eventLocation"
												style={{ height: fromButton ? '.6em' : fromPreview ? '.7em' : '.9em' }}
											>
												{/* Event Location */}
											</div>
											<div
												className="eventDesc"
												style={{ height: fromButton ? '.4em' : fromPreview ? '.6em' : '.8em' }}
											>
												{/* Description */}
											</div>
										</div>
										{/* Materials here if needed? */}
									</div>
								</div>
							)}
						</div>
						{!fromButton && !fromPreview && (
							<h1 className="viewFullAgendaText" style={{ color }}>
								View full agenda
							</h1>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default AgendaPreview;
